import React , {useState , useEffect} from 'react';
import { fetchTotalUnsubscribeEmail } from '../../stores/api_calls/dashboard';
import {
    FaBuysellads,
  } from "react-icons/fa";
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const TotalUnsubscribeEmail = () => {

    const navigate = useNavigate()
    const [total , setTotal] = useState()
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true)
        const getTotal = fetchTotalUnsubscribeEmail()

        getTotal.then((res)=>{
            if(res.data){
                if(res.data.success){
                    // console.log(res.data.data);
                    setTotal(res.data.data)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='total-banner header-card'>
                <p className='header-text'>Unsubscribe Email</p>
                <FaBuysellads style={{width:"80px"}}/>
            </div>
            <div className='total-banner body-card'>
                <p className='active-text'>Total : {isLoading ? 'fetching' : !isLoading&&total? total : 0}</p>
                <div className='goIcon' onClick={()=>navigate("../marketing-emails/unverified", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default TotalUnsubscribeEmail;
